import Modal from 'react-modal'
import LocationList from '@/resources/LocationList.json'

type Props = {
  isOpen: boolean
  mapCode: number
  closeDetailModal: () => void
}

const DetailInfoModal = ({ isOpen, mapCode, closeDetailModal }: Props) => {
  // #region スタイル

  const modalStyle: Modal.Styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(240,240,240,0.7)'
    },
    content: {
      position: 'absolute',
      backgroundColor: '#f0f0f0',
      border: 'solid 1px #000000',
      top: '10%',
      left: '35%',
      right: '35%',
      bottom: '10%',
      padding: '0px'
    }
  }

  const headerStyle: React.CSSProperties = {
    margin: '5px 0px 5px 10px'
  }

  const mainStyle: React.CSSProperties = {
    margin: '10px'
  }

  const imageStyle: React.CSSProperties = {
    width: '350px'
  }

  const infoStyle: React.CSSProperties = {
    lineHeight: '10px'
  }

  const buttonsStyle: React.CSSProperties = {
    textAlign: 'right'
  }

  // #endregion スタイル

  return (
    <Modal isOpen={isOpen} ariaHideApp={false} style={modalStyle}>
      <h1 style={headerStyle}>詳細情報</h1>
      <main style={mainStyle}>
        <img style={imageStyle} src={`images/${String(mapCode).padStart(3, '0')}.png`} />
        <p style={infoStyle}>場所コード（10進数）：{LocationList['grotto-locations'][mapCode - 1]?.code}</p>
        <p style={infoStyle}>
          場所コード（16進数）： 0x
          {LocationList['grotto-locations'][mapCode - 1]?.code.toString(16).toUpperCase().padStart(2, '0')}
        </p>
        <p style={infoStyle}>地名：{LocationList['grotto-locations'][mapCode - 1]?.['region-name']}</p>
        <p style={infoStyle}>水：{LocationList['grotto-locations'][mapCode - 1]?.water ? '有' : '無'}</p>
        <p style={infoStyle}>山：{LocationList['grotto-locations'][mapCode - 1]?.mountain ? '有' : '無'}</p>
        <p style={infoStyle}>木：{LocationList['grotto-locations'][mapCode - 1]?.tree ? '有' : '無'}</p>
        <p style={infoStyle}>道：{LocationList['grotto-locations'][mapCode - 1]?.road ? '有' : '無'}</p>
        <p style={infoStyle}>坂：{LocationList['grotto-locations'][mapCode - 1]?.ramp ? '有' : '無'}</p>
        <p style={infoStyle}>橋：{LocationList['grotto-locations'][mapCode - 1]?.bridge ? '有' : '無'}</p>
        <p style={infoStyle}>
          立て札：{LocationList['grotto-locations'][mapCode - 1]?.['bulletin-board'] ? '有' : '無'}
        </p>
        <p style={infoStyle}>浅瀬：{LocationList['grotto-locations'][mapCode - 1]?.ford ? '有' : '無'}</p>
        <p style={infoStyle}>
          毒沼：{LocationList['grotto-locations'][mapCode - 1]?.['poison-swamp'] ? '有' : '無'}
        </p>
        <p style={infoStyle}>
          枯れ木：{LocationList['grotto-locations'][mapCode - 1]?.['dead-tree'] ? '有' : '無'}
        </p>
        <div style={buttonsStyle}>
          <button onClick={closeDetailModal}>閉じる</button>
        </div>
      </main>
    </Modal>
  )
}

export default DetailInfoModal
